import React from 'react';
import IconCube from '../../icons/icon-cube';
import IconUser from '../../icons/icon-user';
import CardTotal from '../components/card-total';
import { useQuery } from '@tanstack/react-query';
import { fetchReportMonthStats } from '../../cores/api/api-dashboard';
import { formatCountNumber, formatCurrency } from '../../utils/format-data';
export default function SectionCardTotal() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const _useQuery = useQuery({
        queryKey: ['fetchReportMonthStats'],
        queryFn: () => fetchReportMonthStats(),
        suspense: true
    }), data = _useQuery.data;
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-4 gap-6"
    }, /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u5408\u8A08\u7537\u6027\u30E6\u30FC\u30B6\u30FC",
        total: formatCountNumber((_a = data === null || data === void 0 ? void 0 : data.data.cumulative_male_users) !== null && _a !== void 0 ? _a : 0),
        growthTitle: ((_b = data === null || data === void 0 ? void 0 : data.data.diff_male_users_percent) !== null && _b !== void 0 ? _b : 0) > 0 ? '前月とアップ' : '前月と下がる',
        isDown: ((_c = data === null || data === void 0 ? void 0 : data.data.diff_male_users_percent) !== null && _c !== void 0 ? _c : 0) <= 0,
        change_percent: (_d = data === null || data === void 0 ? void 0 : data.data.diff_male_users_percent) !== null && _d !== void 0 ? _d : 0,
        icon: /*#__PURE__*/ React.createElement(IconUser, {
            className: "text-[#8280ff]"
        })
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u5408\u8A08\u5973\u6027\u30E6\u30FC\u30B6\u30FC",
        total: formatCountNumber((_e = data === null || data === void 0 ? void 0 : data.data.cumulative_female_users) !== null && _e !== void 0 ? _e : 0),
        growthTitle: ((_f = data === null || data === void 0 ? void 0 : data.data.diff_female_users_percent) !== null && _f !== void 0 ? _f : 0) > 0 ? '前月とアップ' : '前月と下がる',
        isDown: ((_g = data === null || data === void 0 ? void 0 : data.data.diff_female_users_percent) !== null && _g !== void 0 ? _g : 0) <= 0,
        change_percent: (_h = data === null || data === void 0 ? void 0 : data.data.diff_female_users_percent) !== null && _h !== void 0 ? _h : 0,
        icon: /*#__PURE__*/ React.createElement(IconUser, {
            className: "text-green-400"
        })
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u30C8\u30FC\u30BF\u30EB\u30B5\u30D6\u30B9\u30AF",
        total: formatCurrency({
            value: (_j = data === null || data === void 0 ? void 0 : data.data.total_subscription_sales) !== null && _j !== void 0 ? _j : 0
        }),
        growthTitle: ((_k = data === null || data === void 0 ? void 0 : data.data.diff_subscription_percent) !== null && _k !== void 0 ? _k : 0) > 0 ? '前月とアップ' : '前月と下がる',
        isDown: ((_l = data === null || data === void 0 ? void 0 : data.data.diff_subscription_percent) !== null && _l !== void 0 ? _l : 0) <= 0,
        change_percent: (_m = data === null || data === void 0 ? void 0 : data.data.diff_subscription_percent) !== null && _m !== void 0 ? _m : 0,
        icon: /*#__PURE__*/ React.createElement(IconCube, null)
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "\u30C8\u30FC\u30BF\u30EB\u3044\u3044\u306D\u58F2\u4E0A",
        total: formatCurrency({
            value: (_o = data === null || data === void 0 ? void 0 : data.data.total_like_sales) !== null && _o !== void 0 ? _o : 0
        }),
        growthTitle: ((_p = data === null || data === void 0 ? void 0 : data.data.diff_like_percent) !== null && _p !== void 0 ? _p : 0) > 0 ? '前月とアップ' : '前月と下がる',
        isDown: ((_q = data === null || data === void 0 ? void 0 : data.data.diff_like_percent) !== null && _q !== void 0 ? _q : 0) <= 0,
        change_percent: (_r = data === null || data === void 0 ? void 0 : data.data.diff_like_percent) !== null && _r !== void 0 ? _r : 0,
        icon: /*#__PURE__*/ React.createElement(IconCube, null)
    }));
}
